/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPayee401kFund.ts                 *
 *                                                                             *
 /*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/payee-401k-fund-lookup";

export class AutogenModelPayee401kFund<RowType extends ModelRow> extends Endpoint<RowType, RowPayee401kFundFields> {
    constructor(ctor: RowConstructor) {
        super(endpointPath, ctor);
    }
}

export class AutogenRowPayee401kFund extends ModelRow<RowPayee401kFundFields> {
    constructor(values?: Partial<RowPayee401kFundFields>) {
        super(endpointPath, true, values);
    }
}

export interface RowPayee401kFundFields {
    company_id: string;
    descr: string;
    id: string;
}
